module.exports = __webpack_public_path__ + "img/tinteccnc_m_history.c11c1c28.svg";